import Controller from '@ember/controller';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { type FundGroupsIndexRouteModel } from 'donor-elf-web/routes/admin/fund-groups';
import fuzzysort from 'fuzzysort';

export default class FundGroupsIndexController extends Controller {
  @service declare settings: any;

  model!: FundGroupsIndexRouteModel;

  queryParams = ['q'];
  @tracked q = '';

  get filteredItems() {
    if (isEmpty(this.q)) {
      return this.model.fundGroups;
    }
    return fuzzysort
      .go(this.q, this.model.fundGroups, { key: 'name', threshold: -10000 })
      .map((x) => x.obj);
  }

  @action
  templateWillDestroy() {
    this.q = '';
  }

  @action
  handleSearchInput(e: any) {
    this.q = e.target.value;
  }
}
